export function useServiceWorker() {
  return async () => {
    if ("serviceWorker" in navigator) {
      try {
        const apiBaseUrl = (
          process.env.BUN_PUBLIC_SERVER_URL ?? window.location.origin
        ).replace(/\/$/, "");


        const workerUrl = new URL("/notification-worker.js", window.location.origin);
        workerUrl.searchParams.set("apiBaseUrl", apiBaseUrl);

        const registration = await navigator.serviceWorker.register(
          workerUrl,
          {
            type: "module",
            scope: "/",
          },
        );
        if (registration.installing) {
          console.log("Service worker installing");
        } else if (registration.waiting) {
          console.log("Service worker installed");
        } else if (registration.active) {
          console.log("Service worker active");
        }
      } catch (error) {
        console.error(`Registration failed with ${error}`);
        throw error;
      }
    }
  };
}

export async function refreshServiceWorkers() {
          // Unregister any existing service workers first
        const registrations = await navigator.serviceWorker.getRegistrations();
        for (let registration of registrations) {
          await registration.unregister();
          console.log("Unregistered old service worker");
        }

}

export function useNotificationPermission() {
  return async () => {
    const permission = await window.Notification.requestPermission();
    if (permission !== "granted") throw new Error("permission not granted");
  };
}
